export default __webpack_public_path__ + "static/media/data-school.4d56e5fc.webp";